module.exports = __webpack_public_path__ + "static/media/coverteye-logo.97f04744.png";